import React, { useState, useEffect } from 'react'
import Select from 'react-select'
import { HTTP } from '../../../api/resources'
import ToggleSwitch from '../../ToggleSwitch/ToggleSwitch'

export default function AudienceModal({post, save, close, postSkin, availableAudiences, team, saving}) {
    const allowManagerPosts = true
    const [postData, setPostData] = useState(post)

    const [audienceOptions, setAudienceOptions ] = useState(availableAudiences)
    const _usingAudience = postSkin.audience_members && postSkin.audience_members.length > 0;
    const [usingAudience, setUsingAudience] = useState(_usingAudience);

    const hasPotentialAudience = postData.post_type && postData.post_type == 'project' ? 
    audienceOptions.filter(o => o.type == 'project') && audienceOptions.filter(o => o.type == 'project').length > 0 :
    audienceOptions.filter(o => o.type == 'user') && audienceOptions.filter(o => !o.type || o.type == 'user').length > 1
    
      useEffect(() => {
        if(postData.owner) {
          const fetchData = async () => {
            const data = await initializeAudienceOptions(postData.owner);
            setAudienceOptions(data.data.users)
            setUsingAudience(false)
          }
    
          fetchData().catch(console.error);
        }
      }, [postData.owner])
    
      const initializeAudienceOptions = async (user) => {
        let userId = user && user.id ? user.id : post.user_id
        return HTTP.get(`/users/${userId}/get_audience.json`)
      }

  return (
    <div>
        <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
            <div className="bg-white mx-auto rounded shadow p-5 cu-width-input">
                <h4>Modify Audience</h4>
                
                <div className="row">
                    <div className="col-md-12">
                    {postData.owner && postData.owner.user_type == 'donor' &&
                        <div className="align-center">
                        <div className="align-center">
                            <div className="form-group">
                            <ToggleSwitch
                                small
                                id="post_type"
                                checked={postData.post_type && postData.post_type == 'project' ? true : false}
                                onChange={checked => {
                                let type = checked ? 'project' : 'user'
                                setPostData(postData => {
                                    return { ...postData, post_type: type, audience: [] }
                                });
                                setUsingAudience(false)
                                }}
                            />
                            {postData.post_type && postData.post_type == 'project' &&
                                <label htmlFor="post_type">{team.project_title} post</label>
                            }
                            {(!postData.post_type || postData.post_type !== 'project') &&
                                <label htmlFor="post_type">{team.donor_title} post</label>
                            }
                            </div>
                        </div>
        
                        <div className="col-md-6 align-center">
                        </div>
                        </div>
                    } 
    
                    <div className="form-group">
                        <label htmlFor="audience">Who can see this post?</label>
    
                        {!usingAudience && (<div>
                        <span>Visible to all your connections within Clarity. </span>
                        {hasPotentialAudience && <span><u><span className="text-primary cursor-pointer" onClick={() => setUsingAudience(true) }>Change audience</span></u>.</span>}
                        </div>)}
    
                        {usingAudience && (
                        <>
                            {(!postData.post_type || postData.post_type == 'user') &&
                            <>
                            <div className="input-group">
                            <Select
                                className="w-100 select-audience"
                                classNamePrefix="select-audience"
                                isMulti
                                value={postData.audience}
                                onChange={(value) => {
                                    setPostData({...postData, audience: value})
                                }}
                                options={
                                postData.post_type == 'project' ?
                                audienceOptions.filter(option => option.type && option.type == 'project') :
                                audienceOptions.filter(option => !option.type || option.type == 'user')
                                }
                                getOptionLabel={audience => `${audience.name}`}
                                getOptionValue={audience => audience.id }
                            />
                            </div>
                            <div className="description">
                            Leave empty for all your connections within Clarity to see this post.
                            </div>
                        </>}
                        {postData.post_type && postData.post_type == 'project' &&
                            <>
                            <div className="input-group">
                                <Select
                                className="w-100 select-audience"
                                classNamePrefix="select-audience"
                                value={postData.audience[0]}
                                onChange={(value) => {
                                    setPostData(postData => {
                                    return { ...postData, audience: [value], public_project_audience: false }
                                    });
                                }}
                                options={
                                    postData.post_type == 'project' ?
                                    audienceOptions.filter(option => option.type && option.type == 'project') :
                                    audienceOptions.filter(option => !option.type || option.type == 'user')
                                }
                                getOptionLabel={audience => `${audience.name}`}
                                getOptionValue={audience => audience.id }
                                />
                            </div>
                            <div className="description">
                                You can only choose one {team.project_title.toLowerCase()} per post and it is required
                            </div>
                            </>
                        }
                        </>
                    )}
                    </div>
                    {postData.post_type == 'project' && postData.audience && postData.audience.length > 0 && !postData.audience[0].public_disabled && 
                    (!postData.audience[0].blocked_sponsors || postData.audience[0].blocked_sponsors.length < 1 || 
                        !postData.audience[0].blocked_sponsors.includes(postData.owner.id)) &&
                    <div className="align-center">
                        <div className="form-group">
                        <ToggleSwitch
                            small
                            id="public_project_audience_toggle"
                            checked={postData.public_project_audience}
                            onChange={checked => {
                            setPostData({...postData, public_project_audience: checked})
                            }}
                        />
                        <label htmlFor="public_project_audience_toggle">
                            {postData.public_project_audience &&
                            <>
                                Public post (<small>visible to {team.project_title.toLowerCase()} admins and sponsors </small>)
                            </>
                            }
                            {!postData.public_project_audience &&
                            <>
                                Private post (<small>visible only to {team.project_title.toLowerCase()} admins</small>)
                            </>
                            }
                        </label>
                        </div>
                    </div>
                    }
                    </div>
                </div>
                <div className="pt-3 text-center">
                    <button onClick={() => save(postData)} type="button" className="btn btn-primary mr-2" disabled={saving}>
                        {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                        Update
                    </button>

                    <button onClick={() => close(null)} type="button" className="btn btn-secondary mr-2" disabled={saving}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
  )
}
